import { SupportedLanguage } from './localization';

export function getLocales() {
  const languages = navigator.languages || [navigator.language];
  return languages.map(lang => ({
    languageCode: lang.split('-')[0],
    scriptCode: undefined,
    countryCode: lang.split('-')[1] || undefined,
    languageTag: lang,
    isRTL: false
  }));
}

export function findBestLanguageTag(languageTags: string[]) {
  const userLanguages = navigator.languages || [navigator.language];
  for (const userLang of userLanguages) {
    const baseLang = userLang.split('-')[0];
    if (languageTags.includes(baseLang)) {
      return { languageTag: baseLang };
    }
  }
  return null;
}
